import { t } from 'i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

const isHighlyVulnerable = (country?: string) => {
  switch (country) {
    case 'Burkina Faso':
    case 'Ethiopia':
    case 'Rwanda':
    case 'Tanzania':
    case 'Togo':
    case 'Uganda':
    case 'Bangladesh':
    case 'Haiti':
      return true;
    default:
      return false;
  }
};

export const getNote = (childObject?: ChildDetails) => {
  if (!childObject) {
    return '';
  }
  const noteList = [];

  if (childObject.isInHivAffectedArea) {
    noteList.push(t('bio:livesInArea'));
  }

  if (
    childObject.isSpecialNeeds ||
    childObject.physicalDisability.length > 0 ||
    childObject.chronicIllness.length > 0
  ) {
    noteList.push(t('bio:childWithDisability'));
  }

  if (isHighlyVulnerable(childObject?.country || '') === true) {
    noteList.push(t('bio:isHighlyVulnerable'));
  }

  if (childObject.isOrphan) {
    noteList.push(
      t('bio:isOrphaned', {
        context: childObject.gender.toString(),
      }),
    );
  }

  if (noteList.length === 0) {
    return '';
  }
  if (noteList.length === 1) {
    return t('bio:notes', {
      context: 'one',
      childName: childObject.name.preferred,
      koreanName: childObject.hangul.preferred,
      firstNote: noteList[0],
    });
  }
  if (noteList.length === 2) {
    return t('bio:notes', {
      context: 'two',
      childName: childObject.name.preferred,
      koreanName: childObject.hangul.preferred,
      firstNote: noteList[0],
      lastNote: noteList[1],
    });
  }
  if (noteList.length >= 3) {
    return t('bio:notes', {
      context: 'other',
      childName: childObject.name.preferred,
      koreanName: childObject.hangul.preferred,
      firstNote: noteList[0],
      additionalNotes: noteList
        .slice(1, noteList.length - 1)
        .join(t('bio:localeFormat') === 'ko' ? '. ' : ', '),
      lastNote: noteList[noteList.length - 1],
    });
  }
};
